import { create } from 'zustand'

type AnnouncementStore = {
  height: number
  setHeight: (height: number) => void
}

export const useAnnouncementHeight = create<AnnouncementStore>((set) => ({
  height: 0,
  setHeight: (height) => set({ height }),
})) 